import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { BuyersResponse } from '../../dto/buyers-dto';
import { BuyersRequest } from '../../dto/buyers-dto';

type FetchBuyersOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export function fetchBuyers(
  baseUrl: string,
  payload: BuyersRequest,
  options?: FetchBuyersOptions,
): Promise<IHttpResponse<BuyersResponse>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<BuyersRequest> = {
    url: `${baseUrl}/api/v2/lead`,
    method: 'POST',
    body: payload,
    headers,
    schemas: {
      request: BuyersRequest,
      response: BuyersResponse,
    },
    ...restOptions,
  };

  return httpCall(request);
}
